<script lang="ts" setup>
/* eslint-disable import-x/no-duplicates -- #layers/base is also imported for feature flag registration side effects. */
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useHead } from '#app/composables/head';
import { useAppConfig } from '#app/config';
import { useFeatureFlagKeyboardShortcuts } from '#layers/base';
import { useNuxtUiLocale } from '#layers/ui';
import { useAppearance } from '~/composables/use-appearance';
import { useAuth } from '~/stores/auth';

// Register feature flags. This import needs to remain intact.
import '#layers/base';
/* eslint-enable import-x/no-duplicates */

const appConfig = useAppConfig();

const { locale } = useI18n();
const { currentUser } = useAuth();
const nuxtUiLocale = useNuxtUiLocale();

useHead({
	htmlAttrs: {
		lang: locale,
		dir: computed(() => nuxtUiLocale.value.dir ?? 'ltr'),
	},
});

useAppearance(() => currentUser.value?.appearance);

useFeatureFlagKeyboardShortcuts();
</script>

<template>
	<NuxtRouteAnnouncer />
	<AiAppContextProvider />
	<DApp :locale="nuxtUiLocale" :tooltip="appConfig.tooltip">
		<AppLoading />
		<NuxtLayout>
			<NuxtPage />
		</NuxtLayout>
	</DApp>
</template>
